// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"acl_wrapper__3tgq4","header":"acl_header__E9ZPF","content":"acl_content__2iMFL"};